import { useEffect, useState } from "react";
import {
  FaHome,
  FaUser,
  FaFolderOpen,
  FaCog,
  FaEnvelope,
} from "react-icons/fa";

export default function MobileBottomNav() {
  const [activeSection, setActiveSection] = useState("");

  const navItems = [
    { href: "#hero", icon: <FaHome />, label: "Home" },
    { href: "#about", icon: <FaUser />, label: "About" },
    { href: "#portfolio", icon: <FaFolderOpen />, label: "Work" },
    { href: "#skills", icon: <FaFolderOpen />, label: "Skills" },
    { href: "#services", icon: <FaCog />, label: "Service" },
    { href: "#contact", icon: <FaEnvelope />, label: "Contact" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll("section[id]");
      let current = "";

      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= window.innerHeight / 3 && rect.bottom >= 100) {
          current = section.id;
        }
      });

      setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="fixed bottom-0 left-0 w-full bg-white dark:bg-black border-t dark:border-gray-500 py-2 px-3 flex justify-between items-center md:hidden z-50 backdrop-blur-lg bg-opacity-80">
      {navItems.map((item) => (
        <NavItem key={item.href} {...item} active={activeSection === item.href.slice(1)} />
      ))}
    </div>
  );
}

function NavItem({ href, icon, label, active }) {
  const handleClick = (e) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`flex flex-col items-center justify-center text-xs cursor-pointer transition-transform duration-200
        bg-transparent active:bg-transparent focus:bg-transparent
        border-none outline-none focus:outline-none active:outline-none
        ${active
          ? "text-primary scale-105 font-semibold"
          : "text-gray-600 dark:text-gray-300 hover:text-primary"
        }`}
    >
      <div className="text-lg mb-1">{icon}</div>
      <span>{label}</span>
    </button>
  );
}

